import { pxToDP } from '@capsicum/common';
import { SkeletonItem } from '@capsicum/common-web';
import { useMemo } from 'react';
import styled, { useTheme } from 'styled-components';

type BorderRadiusType = 'large' | 'small';

export const SportFiltersSkeleton = () => {
	const {
		spacings: { large, xlarge }
	} = useTheme();

	return (
		<S.SportFiltersSkeletonWrapper>
			{useMemo(
				() =>
					Array(6)
						.fill(null)
						.map((_, index) => (
							<SkeletonItem
								borderRadius={pxToDP(large)}
								height={pxToDP(xlarge)}
								key={index}
								width={index === 0 ? 50 : index % 2 ? 100 : 150}
							/>
						)),
				[large, xlarge]
			)}
		</S.SportFiltersSkeletonWrapper>
	);
};

export const TeamSkeleton = ({
	borderRadius = 'small',
	height,
	width
}: {
	borderRadius?: BorderRadiusType;
	height: number;
	width: number;
}) => {
	const {
		spacings: { xlarge, xxsmall }
	} = useTheme();

	const borderRadiusValue = borderRadius === 'small' ? xxsmall : xlarge;

	return (
		<S.TeamSkeleton $height={height} $width={width}>
			<SkeletonItem borderRadius={pxToDP(borderRadiusValue)} height={height} width={width} />
		</S.TeamSkeleton>
	);
};

namespace S {
	export const SportFiltersSkeletonWrapper = styled.div`
		display: flex;
		gap: ${({ theme }) => theme.spacings.xxsmall};
		overflow-x: auto;
		/* for Firefox */
		scrollbar-width: none;
		/* for Chrome, Safari, and Opera */
		&::-webkit-scrollbar {
			display: none;
		}
	`;

	export const SportFilterSkeleton = styled.div`
		margin-right: ${({ theme }) => theme.spacings.xsmall};
	`;

	export const TeamSkeleton = styled.div<{ $height: number; $width: number }>`
		height: ${({ $height }) => $height}px;
		flex-basis: ${({ $width }) => $width}px;
		${({ theme }) => theme.border.radius.medium};
	`;
}
